import {injectable} from "inversify";

import {ApiService} from "@/services/apiService";
import {IInvoiceService} from "@/injection/interfaces";
import {Invoice} from "@/types";
import {AxiosError, AxiosResponse} from "axios";

@injectable()
export class InvoiceService extends ApiService implements IInvoiceService {
  public async getMyInvoices(): Promise<Invoice[]> {
    const response = await this
      ._httpClient
      .get<AxiosResponse<Invoice[]>>(`${process.env.VUE_APP_API_BASE_URL}/api/invoices/mine`)
      .catch(function (error: AxiosError): AxiosResponse<Invoice[]> {
        return error.response as AxiosResponse<Invoice[]>
      })
    return response.data as Invoice[]
  }
}